import React from "react";
import { useFormContext } from "react-hook-form";
import { IParcelaModelo } from "../../../../../../Interfaces/Cobranca/Renegociacao/ModeloRenegociacao/ModeloRenegociacaoInterface";
import { formatMoneyReais } from "../../../../../../Tools/FormatTools";
import { comparaDatasDia } from "../../../../../../Validations/DateValidation";

interface IParcelaModeloProps {
    parcela: IParcelaModelo;
}

export default function ParcelaModelo(props: IParcelaModeloProps) {
    const { register, formState } = useFormContext();

    return (
        <div className="card card-custom p-5">
            <div className="row">
                <h6 className="col-12">{props.parcela.Parcelas}</h6>
                <div className="col-12 col-sm-6 col-lg-3">
                    <label>Número de parcelas:</label>
                    <input
                        className="form-control"
                        name={`parcelas.p${props.parcela.Num_MvPar}.Qtde_MvPar`}
                        ref={register({
                            valueAsNumber: true,
                        })}
                        defaultValue={props.parcela.Qtde_MvPar}
                        type="number"
                    />
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                    <label>Vencimento 1ª parcela:</label>
                    <input
                        className={`form-control ${
                            formState.errors.parcelas?.[
                                `p${props.parcela.Num_MvPar}`
                            ]?.dataPrimeiraParcela
                                ? "is-invalid"
                                : ""
                        }`}
                        type="date"
                        name={`parcelas.p${props.parcela.Num_MvPar}.dataPrimeiraParcela`}
                        defaultValue={props.parcela.dataPrimeiraParcela?.substr(
                            0,
                            10
                        )}
                        ref={register({
                            validate: (date) =>
                                comparaDatasDia(
                                    new Date(`${date}T23:59Z`),
                                    new Date()
                                )
                                    ? true
                                    : "Data Retroativa!",
                        })}
                    />
                    <div className="invalid-feedback">
                        {
                            formState.errors.parcelas?.[
                                `p${props.parcela.Num_MvPar}`
                            ]?.dataPrimeiraParcela?.message
                        }
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="d-flex flex-wrap justify-content-evenly">
                        <span className="text-center align-middle p-2">
                            <div className="font-weight-bold text-muted mb-1">
                                Tipo do Fluxo
                            </div>
                            <div className="font-size-lg font-weight-bolder text-dark-75">
                                {props.parcela.tipoFluxo}
                            </div>
                        </span>
                        <span className="text-center align-middle p-2">
                            <div className="font-weight-bold text-muted mb-1">
                                Valor do Fluxo
                            </div>
                            <div className="font-size-lg font-weight-bolder text-dark-75">
                                {formatMoneyReais(props.parcela.valorFluxo)}
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
